export const FR = (props: React.ComponentPropsWithoutRef<'svg'>) => (
  <svg
    aria-hidden="true"
    fill="none"
    height="24"
    viewBox="0 0 32 24"
    width="32"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_9104_10919)">
      <path d="M0 0H32V24H0V0Z" fill="white" />
      <path d="M0 0H10.665V24H0V0Z" fill="#000091" />
      <path d="M21.335 0H32V24H21.335V0Z" fill="#E1000F" />
    </g>
    <defs>
      <clipPath id="clip0_9104_10919">
        <rect fill="white" height="24" width="32" />
      </clipPath>
    </defs>
  </svg>
)
